import React from 'react';
import PropTypes from 'prop-types';
import { VelocityComponent } from 'velocity-react';
import { H2 } from './containers/Headers';
import Spinner from './spinner/Spinner';
import TranslatedCopy from '../intl/TranslatedCopy';

const TRANSITION_DURATION = 300;
const wrapperTransitionProps = isVisible => ({
  animation: { opacity: isVisible ? 1 : 0 },
  duration: TRANSITION_DURATION,
  display: isVisible ? 'flex' : 'none'
});
const spinnerTransitionProps = isVisible => {
  const delay = isVisible ? 125 : 0;
  const duration = TRANSITION_DURATION - delay;

  return {
    animation: { translateY: isVisible ? 0 : '+=10px' },
    delay,
    duration
  };
};

export const LoadingOverlay = ({ isVisible, message }) => (
  <VelocityComponent {...wrapperTransitionProps(isVisible)}>
    <div className='loading-overlay' data-testid='loading_overlay'>
      <VelocityComponent {...spinnerTransitionProps(isVisible)}>
        <div className='spinner-wrapper'>
          <div className='flex-container center u-full-width u-full-height'>
            <div>
              <H2>{message || <TranslatedCopy id='global.loading' values={{ title: '' }} />}</H2>
            </div>
            <div style={{ position: 'relative', top: '15px' }}>
              <Spinner />
            </div>
          </div>
        </div>
      </VelocityComponent>
    </div>
  </VelocityComponent>
);

LoadingOverlay.defaultProps = {
  isVisible: false,
  message: ''
};

LoadingOverlay.propTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string
};

export default LoadingOverlay;
